import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { get } from 'lodash';
import { getArtworkUrl } from '../utils/Contentful';

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
`;

const Description = styled.div`
  text-align: right;
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 0.25rem 1rem;
  font-size: var(--fs-base);
  color: var(--c-manatee);
`;

const FeaturedImage = ({ featuredImage }) => {
  const description = get(featuredImage, 'fields.description');
  return (
    <Wrapper>
      <img src={getArtworkUrl(featuredImage)} alt="" />
      <Overlay />
      {description && <Description>{description}</Description>}
    </Wrapper>
  );
};

FeaturedImage.propTypes = {
  featuredImage: PropTypes.object.isRequired,
};

export default FeaturedImage;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/article/FeaturedImage.js